module.exports = __webpack_public_path__ + "assets/ic_narver.cda2397e.svg";